const initialState = {
    newMessages: [],
    isReloadNotifications: false,
    isReloadJobs: false
};

export default initialState;